<script>
  import { domainName, selector } from '../stores.js';
</script>

<div class="d-grid gap-2 mb-4">
  <a href="mailto:?subject=DKIM Results for {$domainName}&amp;body=Here are DKIM results for {$domainName} from Agari. See their report at: https%3A%2F%2Fwww.agari.com%2Fresources%2Ftools%2Fdkim%3Fdomain_name%3D{$domainName}%26selector%3D{$selector}" class="btn btn-1 btn-lg share-btn">Share These Results</a>
</div>

<style>
  .share-btn::before {
    content: '';
    background: url('/modules/custom/fortra_tools/images/share-icon.svg') no-repeat center center;
    box-sizing: content-box;
    color: #fff;
    display: inline-block;
    height: 2rem;
    margin-right: 0.5rem;
    vertical-align: middle;
    width: 2rem;
  }
</style>
